import styled from "styled-components";

export const Scene = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  opacity: 1;
`;

export const Overlay = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0000007d;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;
export const BlackOverlay = styled(Overlay)`
  background-color: #000000;
`;
